<template>
    <div class="d-inline-block trz_fields trz-custom-dropdown mb-1 " >
        <b-dropdown id="dropdown-fields" text="Fields" ref="dropdown" class="mb-1 custom-secodary-btn">
        <b-dropdown-form>
            <b-form-group @submit.stop.prevent>
                <div class="form-group">
                    <b-form-checkbox-group
                        v-model="column_selected"
                        :options="column_options"                            
                        switches 
                        
                    />
                </div>
                <button type="button" @click="setcolumn()" class="btn btn-primary">Save</button>
            </b-form-group>
        </b-dropdown-form>
        </b-dropdown>
    </div>
</template>
<script>    
    
    export default{
        
        mounted() {
            
        },
        components: {
            
        },     
        data(){
            
            
            return {

                
                column_selected: [], // Must be an array reference!
                column_options: [                    
                    { text: 'Nationality', value: 'nationality' },
                    { text: 'Gender', value: 'gender' },
                    { text: 'eTIN', value: 'etin' },
                    { text: 'NID', value: 'nid' },
                    { text: 'Branch', value: 'branch' },
                    { text: 'Employee Code', value: 'employee_code' },
                    { text: 'Date of Birth', value: 'date_of_birth' },
                    { text: 'Joining Date', value: 'date_of_joining' },
                    { text: 'Status', value: 'status' },
                ],
                
                
            }
        },
        methods:{
            
            setcolumn: function()
            {
                this.$cookies.set("column_selected", this.column_selected);
                
                this.$refs.dropdown.hide(true);
            },
            getCustomAttributeData: function()
            {
                if(!this.checkNet()) return false;
                
                axios.get(this.$api_url+'/custom/attibute/listdata' , {
                    params: {
                        
                    }
                }).then(function(response){
                    
                    //console.log(response);
                    //alert(response.data.length);
                    if(response.data.length > 0)
                    {      
                        let tr = [];                  
                        let cr = [];                  
                        response.data.forEach(element => {
                            
                            tr = tr.concat([{ text: element.label , value: element.label }]);
                            cr = cr.concat([{ label: element.label , name: element.label }]);
                            
                        });

                        this.column_options = this.column_options.concat(tr);
                        this.columns = this.columns.concat(cr);                        
                    }  
                    
                    this.columns.forEach((column) => {this.sortOrders[column.name] = -1;});
                    
                }.bind(this));
            },
                        

        },
        
        created: function(){
            
            this.getCustomAttributeData();
            if(this.$cookies.isKey("column_selected"))
            {
                if(this.$cookies.get("column_selected") != null && this.$cookies.get("column_selected") != '') 
                    this.column_selected = this.$cookies.get("column_selected").split(',');
            }        
            
        }
    }
</script>